import pushClevertapEvent from 'clevertap/pushClevertapEvent';

import formatDate from 'clevertap/formatDate';
import { getToggleAllDayState } from 'clevertap/hourFilter';
import moment from 'moment';

export function reportsInvoiceStart({ outletIds, startDate, endDate }) {
  pushClevertapEvent('Report Invoice Start', {
    'Current Selected Outlet': outletIds,
    'Toggle All Day': getToggleAllDayState(endDate),
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate),
  });
}

export function reportsInvoicesSelect({ invoice }) {
  pushClevertapEvent('Report Invoice Select', {
    'Current Selected Outlet': invoice.outlet_id,
    'Toggle All Day': getToggleAllDayState(invoice.end_date),
    'Current Time Filter Start': formatDate(invoice.start_date),
    'Current Time Filter End': formatDate(invoice.end_date),
    'Filter Status Selected': invoice.selected_statuses,
    'Invoice Number': invoice.invoice_no,
    'Invoice Date Created': formatDate(invoice.created_at),
    'Invoice Status': invoice.invoice_status,
    'Invoice Total': invoice.total_collected,
    'Invoice Amount Due': invoice.total_amount_due,
    'Invoice Due Date': formatDate(
      moment(invoice.invoice_due_date).endOf('day')
    ),
  });
}
